import React from 'react';
import "tabler-react/dist/Tabler.css";
import { Page, Icon, Card, Dimmer } from "tabler-react";

//import GraficaMisCursos from "../misCursos/GraficaMisCursos";
import GraficaMisCursos from "../misCursos/MisCursos";
//import GraficaRiesgo from "../perfilAlumno/GraficaRiesgo";
import GraficaRiesgo from "../perfilAlumno/PerfilAlumno";
import TablaPlataformas from "../ingresoPlataformas/TablaPlataformas";

function General() {
  return (
    <>
        <Page.Content className="page-general">
            <Page.Title><Icon prefix="fe" name="home" />General</Page.Title>
            <div className="grid-graficas">
            <Card className="grafica-col-1" title="Mis Cursos" isCollapsible isFullscreenable >
              <Card.Body>
                <Dimmer loader>
                  <GraficaMisCursos vistaGeneral="general"/>
                </Dimmer>
              </Card.Body>
            </Card>
            <Card className="grafica-col-2 grafica-riesgo" title="Riesgo" isCollapsible isFullscreenable>
              <Card.Body>
                <Dimmer loader>
                  <GraficaRiesgo vistaGeneral="general"/>
                </Dimmer>
              </Card.Body>
            </Card>
          </div>
          <Card>
            <Card.Body>
                <Dimmer loader>
                    <TablaPlataformas />
                </Dimmer>
            </Card.Body>
          </Card>
        </Page.Content>
    </>
  );
}

export default General;